import { useCallback } from 'react'
import { InternalAxiosRequestConfig } from 'axios'

import { useRequestInterceptor } from './useRequestInterceptor.js'

export const useRequestHeader = (header: string, valueOrGetter?: string | (() => string)): void => {
  const onFulfilled = useCallback(
    (config: InternalAxiosRequestConfig) => {
      const value = typeof valueOrGetter === 'function' ? valueOrGetter() : valueOrGetter

      if (value) {
        return { ...config, headers: config.headers.set(header, value) }
      }

      return config
    },
    [header, valueOrGetter]
  )

  useRequestInterceptor(onFulfilled)
}
